import React, { useState } from "react";
import States from "../../Pages/States";

const DoLaundry = (props) => {
  const { onChange, formik } = props;
  const [yesOnsite, setYesOnsite] = useState(false);
  const [pickup, setPickup] = useState("");
  const [pickupAddress, setPickupAddress] = useState(null);

  const homeCheckedSelected = (e) => {
    let currentState = e.target.value;
    if (currentState === "onsite") {
      setYesOnsite(false);
    } else {
      setYesOnsite(true);
    }
  };

  const handleFatoryLocation = (e) => {
    const currentState = e.target.value;
    setPickupAddress(currentState);
    if (currentState === "abuja") {
      return formik.setFieldValue(
        "pick_up_address",
        "No. 28 Tennesse Crescent, Ministers hill Maitama, Abuja"
      );
    } else if (currentState === "kaduna") {
      formik.setFieldValue(
        "pick_up_address",
        "Suite 4 Ground Floor, Hamza Zayad House, NO 10 Muhammadu Buhari Way, City Centre 800283, Kaduna"
      );
    }
  };
  const pickupHandler = (e) => {
    const currentState = e.target.value;
    setPickup(currentState);
  };
  return (
    <>
      <div>
        <p>Pick Up</p>
        <select
          className="form-select style_form form-select-lg mb-3 shadow-none"
          aria-label=".form-select-lg example"
          name="pick_up"
          onChange={(e) => {
            pickupHandler(e);
            onChange(e);
          }}
        >
          <option value="">Select Pickup Location</option>
          <option value="onsite">Drop-off (Send to our factory)</option>
          <option value="home-pickup">Home Pickup</option>
        </select>
      </div>
      {pickup === 'home-pickup' && (
        <div className="home_delivery">
          <p className="p_add">Pickup Address</p>
          <textarea
            name="pick_up_address"
            onChange={onChange}
            placeholder="Enter Pickup Address"
            className="style_textarea"
          ></textarea>
        </div>
      )}

      <div>
        <div className="">
          <p className="text-base">Factory Location</p>
          <select
            className="form-select style_form form-select-lg mb-3 shadow-none"
            aria-label=".form-select-lg example"
            name="factory_location"
            onChange={(e) => {
              onChange(e);
              handleFatoryLocation(e);
            }}
          >
            <option value="">Select Factory Location</option>
            <option value="abuja">Abuja</option>
            <option value="kaduna">Kaduna</option>
          </select>
        </div>
      </div>

      {pickupAddress === "kaduna" && (
        <div className="k_location">
          <p className="p_add ">PickUp Location</p>
          <div>
            Suite 4 Ground Floor, Hamza Zayad House, NO 10 Muhammadu Buhari Way,
            City Centre 800283, Kaduna
          </div>
        </div>
      )}

      {pickupAddress === "abuja" && (
        <div className="pickup_location">
          <p className="p_add ">PickUp Location</p>
          <div>No. 28 Tennesse Crescent, Ministers hill Maitama, Abuja</div>
        </div>
      )}

      <div>
        {pickup === "home" && (
          <div className="">
            <p className="">Pickup Address</p>
            <textarea
              name="pick_up_address"
              onChange={onChange}
              placeholder="Enter Delivery Address"
              className="style_textarea"
            ></textarea>

            {/* <States /> */}
          </div>
        )}
      </div>

      <div>
        <p>Delivery</p>
        <select
          className="form-select style_form form-select-lg mb-3 shadow-none"
          aria-label=".form-select-lg example"
          // checked={!!yesOnsite}
          name="delivery"
          onChange={(e) => {
            formik.handleChange(e);
            homeCheckedSelected(e);
          }}
        >
          <option value="">Select Delivery Type</option>
          <option value="onsite">On Site</option>
          <option value="home-delivery">Home Delivery</option>
        </select>
      </div>

      <div className="delivery_address">
        {yesOnsite && (
          <div className="home_delivery">
            <p className="p_add">Delivery Address</p>
            <textarea
              name="delivery_address"
              onChange={onChange}
              placeholder="Enter Delivery Address"
              className="style_textarea"
            ></textarea>

            <States formik={formik} />
          </div>
        )}
      </div>
    </>
  );
};

export default DoLaundry;
